module.exports = __webpack_public_path__ + "static/media/update.b32b55c4.svg";